import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import BrIcons from '@components/BrIcons';
import ColorStyles from '@components/ColorStyles';
import DropDownSection from './DropDownSection';
import './UnifiedFilter.scss';

const UnifiedFilter = (props) => {
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const toggleOpenState = () => {
    setIsOpen((isOpen) => !isOpen);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [dropdownRef]);

  const className = isOpen ? cn('unified-filter', 'active') : 'unified-filter';
  return (
    <div ref={dropdownRef} className={className}>
      <div>
        <div onClick={toggleOpenState} className="toggle-btn">
          <BrIcons.Filter className="star-column-icon" colorStyle={ColorStyles.GRAY} />
          Filters
        </div>
      </div>
      {isOpen ? <DropDownSection {...props} setIsOpen={setIsOpen} /> : null}
    </div>
  );
};

UnifiedFilter.propTypes = {
  unifiedFilterState: PropTypes.object,
  applyUnifiedFilter: PropTypes.func,
  isDataLoading: PropTypes.bool,
};

export default UnifiedFilter;
